import React from 'react'
import { DateColumn, Column } from '@sencha/ext-modern'
import {
	DateTimePickerComponent,
	// Inject, MaskedDateTime
} from '@syncfusion/ej2-react-calendars'

import { nullDate } from 'tyan/public/utility'
import { getSyncfusionEditProps } from './utilities'

const render = ({ _datetime: text, dataIndex, format, unit/*'S' 表示到秒, 否则到分钟 */, align = 'center', handleEdit, edit, ...rest }) => {
	format = format || (unit === 'S' ? 'Y/m/d H:i:s' : 'Y/m/d H:i')
	const renderer = (originalValue, record, dataIndex) => {
		const { data: { id } = {}, data } = record || {}
		// 转换为日期格式
		const value = originalValue && originalValue !== nullDate && Tyan.Date.getSecondLocal(originalValue) || null

		const handleChange = ({ value }) => {
			value = value ? Tyan.Date.getSecondUtcValue(value) : nullDate
			value !== originalValue && handleEdit && handleEdit({ id, name: dataIndex, newValue: value, oldValue: originalValue, data, record, type: 'datetime' })
		}

		return <div>
			<DateTimePickerComponent
				// openOnFocus
				showClearButton={false}
				{...unit === 'S' ? { format: 'y/MM/dd HH:mm:ss', timeFormat: 'HH:mm:ss' } : { format: 'y/MM/dd HH:mm', timeFormat: 'HH:mm' }}
				// enableMask maskPlaceholder={{ year: 'yyyy', month: 'mm', day: 'dd', hour: 'hh', minute: 'mm' }}
				// enabled={!disabled}
				value={value}
				change={handleChange}
				{...getSyncfusionEditProps(edit, data)}
			>
				{/* <Inject services={[MaskedDateTime]} /> */}
			</DateTimePickerComponent>
		</div>
	}

	return edit
		? <Column {...{ dataIndex, text, align, renderer, ...rest, cell: { bodyStyle: { padding: '0px 12px' } } }} />
		: <DateColumn {...{ dataIndex, text, align, format, ...rest }} />
}

export default render